/* any functionality that external components need, and thus must be exported, goes in this file */
import { isElementFocusable } from '@chegg-ui/utils';

var removeTabindex = function removeTabindex(event) {
  var element = event.currentTarget;
  element.removeAttribute('tabindex');
};

var focusElement = function focusElement(element) {
  if (!isElementFocusable(element)) {
    element.setAttribute('tabindex', '-1');
    element.addEventListener('blur', removeTabindex);
    element.addEventListener('focusout', removeTabindex);
  }

  element.focus();
};

export function useSkipLinkBehavior(props) {
  var mainContentId = props.mainContentId,
      onClick = props.onClick;

  var handleClick = function handleClick(event) {
    var targetElement = document.getElementById(mainContentId);

    if (targetElement === null) {
      console.error("HTMLElement with id=\"".concat(mainContentId, "\" does not exist"));
    } else {
      focusElement(targetElement);
    }

    onClick && onClick(event);
  };

  return {
    onClick: handleClick
  };
}